const filters = {
    /**
     * 功能：showName利用全局过滤器去掉最后的null
     */
    nameFilter(val) {
        if(val&&val.indexOf('null')>-1){
            return val.slice(0,val.lastIndexOf(' null'))
        }else{
            return val
        }
    }
}
export default (Vue) => {
    Object.keys(filters).forEach(key => {
        Vue.filter(key, filters[key])
    })
}


// WEBPACK FOOTER //
// ./src/filters/index.js